import { observer } from 'mobx-react-lite';
import NewsList from './news-list';
import { useParams } from 'react-router-dom';
import NewsEdit from './news-edit';

export default observer(function News() {
    const { code } = useParams();

    return (
        <>
            {code ? <NewsEdit /> : <NewsList />}
        </>
    );
});
